export default __webpack_public_path__ + "static/media/noa-36.23a60a34.jpg";